/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const GetAuthenticationSsoStatus = {
  id: 'authentication.sso-status.get',
  tag: 'Authentication',
  summary: 'SSO Status',
  description: 'Find out how many SSO configurations are present',
  method: 'get',
  route: () => `/authentication/sso/status`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            status: z.union([z.literal('none'), z.literal('single'), z.literal('multiple')]),
            organizationId: z.string().nullish(),
            organizationName: z.string().nullish(),
            thumbnail: z.string().nullish(),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
